import React from "react";
import { MODE_FIELDS, MODE_LABELS, WATER_LEVEL_RANGE } from "./cupConstants";
import NumberInput from "../../../../../atoms/NumberInput";

export default function SettingsPanel({ cup, mode, onCupField, onModeField }) {
  if (!cup) {
    return <div className="flex-1 p-4 text-fifth">Fincan seçin.</div>;
  }

  const modeData = cup.modes?.[mode] || {};
  const [wlLo, wlHi] = WATER_LEVEL_RANGE;

  return (
    <div className="flex-1 flex flex-col gap-3">
      <h4 className="text-sm font-semibold text-fifth">
        {cup.name} × {MODE_LABELS[mode]}
      </h4>

      <div className="border rounded p-3 bg-second/30">
        <label className="block text-xs text-fifth mb-1">
          Su Seviyesi (mod-bağımsız)
        </label>
        <NumberInput
          value={cup.waterLevel}
          min={wlLo}
          max={wlHi}
          onChange={(v) => onCupField(cup.id, "waterLevel", v)}
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {MODE_FIELDS.map((field) => {
          const [lo, hi] = field.range;
          const v = modeData[field.key];
          const oor = typeof v !== "number" || v < lo || v > hi;
          return (
            <div
              key={field.key}
              className={`border rounded p-3 ${
                oor ? "border-red-500" : "border-fifth"
              }`}
            >
              <label
                className="block text-xs text-fifth mb-1"
                title={`${lo}–${hi}`}
              >
                {field.label}
              </label>
              <NumberInput
                value={v}
                min={lo}
                max={hi}
                onChange={(val) => onModeField(cup.id, mode, field.key, val)}
              />
              {oor && (
                <span className="text-xs text-red-600">
                  {lo}–{hi} arası olmalı
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
